/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Video_TitleInputs */

const en_directory_taxonomy_use_cases_video_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produce video`)
};

const zh_directory_taxonomy_use_cases_video_title = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制作视频`)
};

/**
* | output |
* | --- |
* | "Produce video" |
*
* @param {Directory_Taxonomy_Use_Cases_Video_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_video_title = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Video_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Video_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_video_title(inputs)
	return zh_directory_taxonomy_use_cases_video_title(inputs)
});
export { directory_taxonomy_use_cases_video_title as "directory.taxonomy.use-cases.video.title" }